import { BybButton } from "@Components/common/byb-ds";
import { alpha, Box, Stack, styled, Typography } from "@mui/material";
import type { ComponentProps } from "react";

interface VideoPreviewProps {
  $hasVideo: boolean;
  $imageUrl?: string | null;
}

export const DialogContent = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(5),
  padding: theme.spacing(1),
  textAlign: "center",
}));

export const VideoPreview = styled("button", {
  shouldForwardProp: prop => prop !== "$hasVideo" && prop !== "$imageUrl",
})<VideoPreviewProps>(({ theme, $hasVideo, $imageUrl }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  aspectRatio: "2.5",
  overflow: "hidden",
  border: `1px solid ${theme.palette.dsBase.v200}10`,
  borderRadius: theme.spacing(1.5),
  padding: 0,
  cursor: $hasVideo ? "pointer" : "default",
  backgroundColor: theme.palette.dsSurface.v300,
  backgroundImage: `url(${$imageUrl || ""})`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  "&:hover > *": $hasVideo ? { transform: "scale(1.15)" } : undefined,
}));

export const PlayButton = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 48,
  height: 48,
  borderRadius: "50%",
  backgroundColor: alpha(theme.palette.dsBase.v100, 0.58),
  color: theme.palette.dsBase.v200,
  transition: "transform 150ms ease",
}));

export const ChallengeDetails = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const ChallengeDescription = styled(Typography)({
  width: "85%",
});

export const DialogActions = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));

interface DialogButtonProps extends ComponentProps<typeof BybButton> {
  removePadding?: boolean;
}

export const DialogButton = ({ removePadding, sx, ...props }: DialogButtonProps) => (
  <BybButton
    {...props}
    sx={{
      borderRadius: 999,
      ...(removePadding && { padding: 0 }),
      ...sx,
    }}
  />
);
